/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class LanguageSwitcher {
    public foo(): void {
        console.log('language-switcher')
    }
}

/**
 *     @section 3. Export class
 */

export default new LanguageSwitcher()

// end of language-switcher.ts file
